import { createContext, useContext, useEffect, type ReactNode } from "react";
import type { MeDTO, Permission } from "@easyshop/shared";
import { useMe } from "@/lib/queries";
import { setCurrentOrg } from "@/lib/api";

interface Session {
  me: MeDTO;
  can: (p: Permission) => boolean;
  /** Vue gérant : périmètre limité (pas tout le réseau). */
  isManagerView: boolean;
}

const Ctx = createContext<Session | null>(null);

export function SessionProvider({ me, children }: { me: MeDTO; children: ReactNode }) {
  useEffect(() => {
    setCurrentOrg(me.organization?.id ?? null);
  }, [me.organization?.id]);
  const set = new Set(me.permissions);
  return (
    <Ctx.Provider value={{ me, can: (p) => set.has(p), isManagerView: !me.networkWide }}>{children}</Ctx.Provider>
  );
}

export function useSession(): Session {
  const v = useContext(Ctx);
  if (!v) throw new Error("SessionProvider manquant");
  return v;
}

/** Aide : le chargement de /me reste la source de vérité (rôle, périmètre). */
export { useMe };
